import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api` });

export const getProducts = (params) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug, lang) => api.get(`/products/${slug}`, { params: { lang } }).then((r) => r.data);
export const getFilters = () => api.get("/filters").then((r) => r.data);
export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getAccessories = () => api.get("/accessories").then((r) => r.data);
export const getBundles = () => api.get("/bundles").then((r) => r.data);
export const getBundle = (slug) => api.get(`/bundles/${slug}`).then((r) => r.data);
export const advisorRecommend = (profile, lang, session_id) =>
  api.post("/advisor/recommend", { profile, lang, session_id }).then((r) => r.data);
export const simulatorRecommend = (payload) => api.post("/simulator/recommend", payload).then((r) => r.data);
export const submitWholesale = (payload) => api.post("/wholesale", payload).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const formatEUR = (v) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);

// Streaming advisor chat over SSE
export async function streamAdvisorChat(messages, lang, onDelta, onDone, session_id) {
  const res = await fetch(`${BASE}/api/advisor/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ messages, lang, session_id }),
  });
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split("\n\n");
    buffer = parts.pop();
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith("data:")) continue;
      try {
        const payload = JSON.parse(line.slice(5).trim());
        if (payload.delta) onDelta(payload.delta);
        if (payload.done && onDone) onDone();
      } catch (e) { /* ignore */ }
    }
  }
  if (onDone) onDone();
}

export const badgeTone = (badge) => {
  const b = (badge || "").toLowerCase();
  if (b.includes("value") || b.includes("budget")) return "mint";
  if (b.includes("premium") || b.includes("4k")) return "amber";
  if (b.includes("portable") || b.includes("travel") || b.includes("compact")) return "cyan";
  return "slate";
};
